export default "__VITE_ASSET__85973b77__"